module.exports = __webpack_public_path__ + "media/img/bg-default-816454306ab0d837ba2605ff75e00784.jpg";